export default [
  {
    name: 'Java Бағдарламашы',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    status: 'Өзекті',
    experience: '1-3 жыл',
    area: 'IT технологиялар',
    image: 'java.svg',
    active: false,
    content: {
      load: 'Толық жұмыспен қамту, толық жұмыс күні',
      requirements: [
        'C# білу',
        'T-SQL білу',
        'JavaScript HTML CSS білу',
        'ASP.Net білу',
        'NHibernate білу',
        'SOAP/WSDL білу',
        '.NET Core білу',
        'git-пен жұмыс жасай білу',
      ],
      conditions: [
        'C# білу',
        'T-SQL білу',
        'JavaScript HTML CSS білу',
        'ASP.Net білу',
        'NHibernate білу',
        'SOAP/WSDL білу',
        '.NET Core білу',
        'git-пен жұмыс жасай білу',
      ],
    },
  },
  {
    name: 'UI Дизайнер',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    status: 'Өзекті',
    experience: '1-3 жыл',
    area: 'IT технологиялар',
    image: 'paint-palette.svg',
    active: false,
    content: {
      load: 'Толық жұмыспен қамту, толық жұмыс күні',
      requirements: [
        'C# білу',
        'T-SQL білу',
        'JavaScript HTML CSS білу',
        'ASP.Net білу',
        'NHibernate білу',
        'SOAP/WSDL білу',
        '.NET Core білу',
        'git-пен жұмыс жасай білу',
      ],
      conditions: [
        'C# білу',
        'T-SQL білу',
        'JavaScript HTML CSS білу',
        'ASP.Net білу',
        'NHibernate білу',
        'SOAP/WSDL білу',
        '.NET Core білу',
        'git-пен жұмыс жасай білу',
      ],
    },
  },
  {
    name: 'Картограф',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    status: 'Өзекті',
    experience: '1-3 жыл',
    area: 'Картография',
    image: 'career_map.svg',
    active: false,
    content: {
      load: 'Толық жұмыспен қамту, толық жұмыс күні',
      requirements: [
        'C# білу',
        'T-SQL білу',
        'JavaScript HTML CSS білу',
        'ASP.Net білу',
        'NHibernate білу',
        'SOAP/WSDL білу',
        '.NET Core білу',
        'git-пен жұмыс жасай білу',
      ],
      conditions: [
        'C# білу',
        'T-SQL білу',
        'JavaScript HTML CSS білу',
        'ASP.Net білу',
        'NHibernate білу',
        'SOAP/WSDL білу',
        '.NET Core білу',
        'git-пен жұмыс жасай білу',
      ],
    },
  },
  {
    name: 'Front-end Бағдарламашы',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    status: 'Өзекті',
    experience: '1-3 жыл',
    area: 'IT технологиялар',
    image: 'web-design.svg',
    active: false,
    content: {
      load: 'Толық жұмыспен қамту, толық жұмыс күні',
      requirements: [
        'C# білу',
        'T-SQL білу',
        'JavaScript HTML CSS білу',
        'ASP.Net білу',
        'NHibernate білу',
        'SOAP/WSDL білу',
        '.NET Core білу',
        'git-пен жұмыс жасай білу',
      ],
      conditions: [
        'C# білу',
        'T-SQL білу',
        'JavaScript HTML CSS білу',
        'ASP.Net білу',
        'NHibernate білу',
        'SOAP/WSDL білу',
        '.NET Core білу',
        'git-пен жұмыс жасай білу',
      ],
    },
  },
  {
    name: 'Деректер қорын әзірлеуші',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    status: 'Өзекті',
    experience: '1-3 жыл',
    area: 'IT технологиялар',
    image: 'data-storage.svg',
    active: false,
    content: {
      load: 'Толық жұмыспен қамту, толық жұмыс күні',
      requirements: [
        'C# білу',
        'T-SQL білу',
        'JavaScript HTML CSS білу',
        'ASP.Net білу',
        'NHibernate білу',
        'SOAP/WSDL білу',
        '.NET Core білу',
        'git-пен жұмыс жасай білу',
      ],
      conditions: [
        'C# білу',
        'T-SQL білу',
        'JavaScript HTML CSS білу',
        'ASP.Net білу',
        'NHibernate білу',
        'WSDL білу',
        '.NET Core білу',
        'git-пен жұмыс жасай білу',
      ],
    },
  },
].map(it => ({
  ...it,
  image: require('@/assets/images/' + it.image),
}));
